import { useState, useEffect } from "react"
import Files from "./Files"
export default function FilesTab(props){
    const { optionKey, enableTab, tabSelected } = props
    const [active, setActive] = useState(false)
    useEffect(() => {
        setActive(tabSelected === optionKey)
    }, [enableTab, tabSelected])
    const objProps = {...props, ...{ active }}
    return(
        <div className="flex flex-col gap-8">
            <Files {...objProps} />
        </div>
    )
}